import React, { createContext, useContext, useMemo } from 'react';

const TabsContext = createContext({
  onChange: (evt) => {
    return evt;
  },
  activeTab: '',
});

const useTabsContext = () => {
  return useContext(TabsContext);
};

const TabsProvider = ({ children, activeTab, onChange }) => {
  const api = useMemo(() => {
    return {
      activeTab,
      onChange,
    };
  }, [activeTab, onChange]);
  return <TabsContext.Provider value={api}>{children}</TabsContext.Provider>;
};

export { TabsContext, useTabsContext, TabsProvider };
